(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-core-js', 'd2v-force-js', 'd2v-color-js', 'd2v-viz-js', 'd2v-timer-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-core-js'), require('d2v-force-js'), require('d2v-color-js'), require('d2v-viz-js'), require('d2v-timer-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'ex-force-js'.");
    }
    if (typeof this['d2v-core-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'd2v-core-js' was not found. Please, check whether 'd2v-core-js' is loaded prior to 'ex-force-js'.");
    }
    if (typeof this['d2v-force-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'd2v-force-js' was not found. Please, check whether 'd2v-force-js' is loaded prior to 'ex-force-js'.");
    }
    if (typeof this['d2v-color-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'd2v-color-js' was not found. Please, check whether 'd2v-color-js' is loaded prior to 'ex-force-js'.");
    }
    if (typeof this['d2v-viz-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'd2v-viz-js' was not found. Please, check whether 'd2v-viz-js' is loaded prior to 'ex-force-js'.");
    }
    if (typeof this['d2v-timer-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-force-js'. Its dependency 'd2v-timer-js' was not found. Please, check whether 'd2v-timer-js' is loaded prior to 'ex-force-js'.");
    }
    root['ex-force-js'] = factory(typeof this['ex-force-js'] === 'undefined' ? {} : this['ex-force-js'], kotlin, this['d2v-core-js'], this['d2v-force-js'], this['d2v-color-js'], this['d2v-viz-js'], this['d2v-timer-js']);
  }
}(this, function (_, Kotlin, $module$d2v_core_js, $module$d2v_force_js, $module$d2v_color_js, $module$d2v_viz_js, $module$d2v_timer_js) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var until = Kotlin.kotlin.ranges.until_dqglrj$;
  var random = $module$d2v_core_js.io.data2viz.core.random;
  var Point = $module$d2v_core_js.io.data2viz.core.Point;
  var ForceNode = $module$d2v_force_js.io.data2viz.force.ForceNode;
  var Color = $module$d2v_color_js.io.data2viz.color.Color;
  var listOf = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var filterNotNull = Kotlin.kotlin.collections.filterNotNull_m3lr2h$;
  var throwUPAE = Kotlin.throwUPAE;
  var Unit = Kotlin.kotlin.Unit;
  var forceRadial = $module$d2v_force_js.io.data2viz.force.forceRadial_qbxk35$;
  var forceNBody = $module$d2v_force_js.io.data2viz.force.forceNBody_yo3wig$;
  var forceY = $module$d2v_force_js.io.data2viz.force.forceY_91a3hb$;
  var forceX = $module$d2v_force_js.io.data2viz.force.forceX_xyu5wg$;
  var Pair = Kotlin.kotlin.Pair;
  var newGroup = $module$d2v_viz_js.io.data2viz.viz.newGroup;
  var SimulationEvent = $module$d2v_force_js.io.data2viz.force.SimulationEvent;
  var getCallableRef = Kotlin.getCallableRef;
  var println = Kotlin.kotlin.io.println_s8jyv4$;
  var forceSimulation = $module$d2v_force_js.io.data2viz.force.forceSimulation_5nf56x$;
  var timer = $module$d2v_timer_js.io.data2viz.timer.timer_k9susy$;
  var viz = $module$d2v_viz_js.io.data2viz.viz;
  var Circle = $module$d2v_viz_js.io.data2viz.viz.Circle;
  var selectOrCreateSvg = $module$d2v_viz_js.io.data2viz.viz.selectOrCreateSvg;
  var ParentElement = $module$d2v_viz_js.io.data2viz.viz.ParentElement;
  var throwCCE = Kotlin.throwCCE;
  var width;
  var height;
  var points;
  var olympicColors;
  var olympicCenters;
  var sprite;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var spriteIndexes;
  var simulation;
  function get_simulation() {
    if (simulation == null)
      return throwUPAE('simulation');
    return simulation;
  }
  function set_simulation(simulation_0) {
    simulation = simulation_0;
  }
  function olympicForces$lambda$lambda(f, index, f_0) {
    return olympicCenters.get_za3lpa$(index % 5);
  }
  function olympicForces$lambda$lambda_0(f, f_0, f_1) {
    return 110.0;
  }
  function olympicForces$lambda$lambda_1(f, f_0, f_1) {
    return 8.5;
  }
  function olympicForces$lambda($receiver) {
    $receiver.center = olympicForces$lambda$lambda;
    $receiver.radius = olympicForces$lambda$lambda_0;
    $receiver.strength = olympicForces$lambda$lambda_1;
    return Unit;
  }
  function olympicForces$lambda$lambda_2(f, index, f_0) {
    return -80.0;
  }
  function olympicForces$lambda_0($receiver) {
    $receiver.strength = olympicForces$lambda$lambda_2;
    $receiver.distanceMax = 30.0;
    return Unit;
  }
  var olympicForces;
  function radialForces$lambda$lambda(f, f_0, f_1) {
    return new Point(width / 2, height / 2);
  }
  function radialForces$lambda$lambda_0(f, f_0, f_1) {
    return 200.0;
  }
  function radialForces$lambda$lambda_1(f, f_0, f_1) {
    return 0.3;
  }
  function radialForces$lambda($receiver) {
    $receiver.center = radialForces$lambda$lambda;
    $receiver.radius = radialForces$lambda$lambda_0;
    $receiver.strength = radialForces$lambda$lambda_1;
    return Unit;
  }
  function radialForces$lambda$lambda_2(f, index, f_0) {
    return -20.0;
  }
  function radialForces$lambda_0($receiver) {
    $receiver.strength = radialForces$lambda$lambda_2;
    $receiver.distanceMax = 30.0;
    return Unit;
  }
  var radialForces;
  function diagonalForces$lambda$lambda(f, f_0, f_1) {
    return -1.0;
  }
  function diagonalForces$lambda($receiver) {
    $receiver.strength = diagonalForces$lambda$lambda;
    $receiver.distanceMax = 30.0;
    return Unit;
  }
  function diagonalForces$lambda$lambda_0(f, index, f_0) {
    var pos = (index % 10 + 0.5) * height / 10;
    return index % 4 < 2 ? pos : height - pos;
  }
  function diagonalForces$lambda$lambda_1(f, index, f_0) {
    return 0.06;
  }
  function diagonalForces$lambda_0($receiver) {
    $receiver.y = diagonalForces$lambda$lambda_0;
    $receiver.strength = diagonalForces$lambda$lambda_1;
    return Unit;
  }
  function diagonalForces$lambda$lambda_2(f, index, f_0) {
    var pos = (index % 10 + 0.5) * width / 10;
    return pos;
  }
  function diagonalForces$lambda$lambda_3(f, index, f_0) {
    return 0.06;
  }
  function diagonalForces$lambda_1($receiver) {
    $receiver.x = diagonalForces$lambda$lambda_2;
    $receiver.strength = diagonalForces$lambda$lambda_3;
    return Unit;
  }
  var diagonalForces;
  function spriteForces$lambda$lambda(f, f_0, f_1) {
    return -0.2;
  }
  function spriteForces$lambda($receiver) {
    $receiver.strength = spriteForces$lambda$lambda;
    $receiver.distanceMax = 15.0;
    return Unit;
  }
  function spriteForces$lambda$lambda_0(f, index, f_0) {
    var indexList = spriteIndexes.get_za3lpa$(index % 5);
    if (indexList.isEmpty())
      return -1000.0;
    else {
      var posIndex = index % indexList.size;
      var spritePosition = indexList.get_za3lpa$(posIndex);
      return 170.0 + (spritePosition % sprite.size / 16 | 0) * height / 70.0;
    }
  }
  function spriteForces$lambda$lambda_1(f, index, f_0) {
    return 0.08;
  }
  function spriteForces$lambda_0($receiver) {
    $receiver.y = spriteForces$lambda$lambda_0;
    $receiver.strength = spriteForces$lambda$lambda_1;
    return Unit;
  }
  function spriteForces$lambda$lambda_2(f, index, f_0) {
    var indexList = spriteIndexes.get_za3lpa$(index % 5);
    if (indexList.isEmpty())
      return -1000.0;
    else {
      var posIndex = index % indexList.size;
      var spritePosition = indexList.get_za3lpa$(posIndex);
      return 300.0 + spritePosition % 16 * width / 70.0;
    }
  }
  function spriteForces$lambda$lambda_3(f, index, f_0) {
    return 0.08;
  }
  function spriteForces$lambda_1($receiver) {
    $receiver.x = spriteForces$lambda$lambda_2;
    $receiver.strength = spriteForces$lambda$lambda_3;
    return Unit;
  }
  var spriteForces;
  var forces;
  var forceIndex;
  function root$lambda$lambda$lambda(it) {
    println('SIMULATION ENDS');
    return Unit;
  }
  function root$lambda$lambda($receiver) {
    $receiver.alphaDecay = 0.01;
    $receiver.nodes = points;
    $receiver.on_dosft2$(SimulationEvent.TICK, 'tickEvent', getCallableRef('refresh', function (sim) {
      return refresh(sim), Unit;
    }));
    $receiver.on_dosft2$(SimulationEvent.END, 'endEvent', root$lambda$lambda$lambda);
    return Unit;
  }
  var root;
  function updateSimulation$lambda($receiver, it) {
    var tmp$;
    tmp$ = until(0, forces.get_za3lpa$(forceIndex).second.size).iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      get_simulation().removeForce_61zpoe$(forces.get_za3lpa$(forceIndex).first + '_' + element);
    }
    forceIndex = (forceIndex + 1 | 0) % forces.size;
    $receiver.stop();
    updateSimulation();
    return Unit;
  }
  function updateSimulation() {
    var tmp$;
    tmp$ = until(0, forces.get_za3lpa$(forceIndex).second.size).iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      get_simulation().addForce_i3w8j1$(forces.get_za3lpa$(forceIndex).first + '_' + element, forces.get_za3lpa$(forceIndex).second.get_za3lpa$(element));
    }
    get_simulation().alpha = 1.0;
    get_simulation().velocityDecay = forceIndex === 2 ? 0.05 : 0.4;
    timer(3500.0, void 0, updateSimulation$lambda);
  }
  function refresh$lambda$lambda($receiver) {
    var $receiver_0 = $receiver.element;
    $receiver_0.stroke = null;
    $receiver_0.radius = 2.0 + ($receiver.index / 150 | 0);
    $receiver_0.fill = olympicColors.get_za3lpa$($receiver.index % 5);
    $receiver_0.cx = $receiver.datum.position.x;
    $receiver_0.cy = $receiver.datum.position.y;
    root.add_28ft1f$($receiver.element);
    return Unit;
  }
  function refresh$lambda$lambda_0($receiver) {
    $receiver.element.cx = $receiver.datum.position.x;
    $receiver.element.cy = $receiver.datum.position.y;
    return Unit;
  }
  function refresh$lambda($receiver) {
    $receiver.onEnter = refresh$lambda$lambda;
    $receiver.onUpdate = refresh$lambda$lambda_0;
    return Unit;
  }
  var DOMVizElement = $module$d2v_viz_js.io.data2viz.viz.DOMVizElement;
  var asList = Kotlin.org.w3c.dom.asList_kt9thq$;
  var toViz = $module$d2v_viz_js.io.data2viz.viz.toViz_asww5s$;
  var getKClass = Kotlin.getKClass;
  var newCircle = $module$d2v_viz_js.io.data2viz.viz.newCircle;
  var equals = Kotlin.equals;
  var newLine = $module$d2v_viz_js.io.data2viz.viz.newLine;
  var Line = $module$d2v_viz_js.io.data2viz.viz.Line;
  var newRect = $module$d2v_viz_js.io.data2viz.viz.newRect;
  var Rect = $module$d2v_viz_js.io.data2viz.viz.Rect;
  var IllegalArgumentException_init = Kotlin.kotlin.IllegalArgumentException_init_pdl1vj$;
  var List = Kotlin.kotlin.collections.List;
  var Selection_init = $module$d2v_viz_js.io.data2viz.viz.Selection;
  function selectElement$lambda() {
    return newCircle();
  }
  function selectElement$lambda_0() {
    return newLine();
  }
  function selectElement$lambda_1() {
    return newRect();
  }
  function refresh(sim) {
    var $receiver = root;
    var selector = viz.circle;
    var data = sim.nodes;
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    var select = selector.toString().toLowerCase();
    var $receiver_0 = asList((Kotlin.isType(tmp$ = $receiver, DOMVizElement) ? tmp$ : throwCCE()).domElement.querySelectorAll(select));
    var destination = ArrayList_init(collectionSizeOrDefault($receiver_0, 10));
    var tmp$_3;
    tmp$_3 = $receiver_0.iterator();
    while (tmp$_3.hasNext()) {
      var item = tmp$_3.next();
      destination.add_11rb$(toViz(item));
    }
    var lookupAll = destination;
    tmp$_0 = getKClass(Circle);
    if (equals(tmp$_0, getKClass(Circle)))
      tmp$_1 = selectElement$lambda;
    else if (equals(tmp$_0, getKClass(Line)))
      tmp$_1 = selectElement$lambda_0;
    else if (equals(tmp$_0, getKClass(Rect)))
      tmp$_1 = selectElement$lambda_1;
    else {
      throw IllegalArgumentException_init('Unknown type ' + getKClass(Circle));
    }
    var creator = tmp$_1;
    var selection = new Selection_init(Kotlin.isType(tmp$_2 = lookupAll, List) ? tmp$_2 : throwCCE(), data, creator);
    refresh$lambda(selection);
    selection.processEnterUpdateExit();
  }
  function main(args) {
    var $receiver = selectOrCreateSvg();
    var tmp$;
    $receiver.setAttribute('width', width.toString());
    $receiver.setAttribute('height', height.toString());
    $receiver.append((Kotlin.isType(tmp$ = root, ParentElement) ? tmp$ : throwCCE()).domElement);
  }
  Object.defineProperty(_, 'simulation', {get: get_simulation, set: set_simulation});
  $$importsForInline$$['d2v-viz-js'] = $module$d2v_viz_js;
  _.refresh_qfw90o$ = refresh;
  _.main_kand9s$ = main;
  width = 800.0;
  height = 500.0;
  var $receiver = until(0, 800);
  var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
  var tmp$;
  tmp$ = $receiver.iterator();
  while (tmp$.hasNext()) {
    var item = tmp$.next();
    destination.add_11rb$(new ForceNode(item, new Point(random() * width, random() * height)));
  }
  points = destination;
  olympicColors = listOf([new Color(33224), new Color(0), new Color(15610702), new Color(16560433), new Color(42577)]);
  olympicCenters = listOf([new Point(160.0, 180.0), new Point(400.0, 180.0), new Point(640.0, 180.0), new Point(280.0, 320.0), new Point(520.0, 320.0)]);
  sprite = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 0, 0, 0, 0, 0, 1, 1, 1, 3, 3, 1, 3, 0, 1, 1, 1, 0, 0, 0, 0, 1, 3, 1, 3, 3, 3, 1, 3, 3, 3, 1, 1, 0, 0, 0, 0, 1, 3, 1, 1, 3, 3, 3, 1, 3, 3, 3, 1, 0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 2, 1, 1, 1, 2, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 2, 0, 0, 1, 3, 3, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 0, 0, 1, 3, 3, 3, 0, 0, 2, 1, 2, 2, 2, 3, 2, 3, 2, 1, 1, 0, 3, 0, 1, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4]);
  var $receiver_0 = olympicColors;
  var destination_0 = ArrayList_init(collectionSizeOrDefault($receiver_0, 10));
  var tmp$_0, tmp$_0_0;
  var index = 0;
  tmp$_0 = $receiver_0.iterator();
  while (tmp$_0.hasNext()) {
    var item_0 = tmp$_0.next();
    var tmp$_1 = destination_0.add_11rb$;
    var index_0 = (tmp$_0_0 = index, index = tmp$_0_0 + 1 | 0, tmp$_0_0);
    var $receiver_1 = sprite;
    var destination_1 = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
    var tmp$_2, tmp$_0_1;
    var index_1 = 0;
    tmp$_2 = $receiver_1.iterator();
    while (tmp$_2.hasNext()) {
      var item_1 = tmp$_2.next();
      var tmp$_3 = destination_1.add_11rb$;
      var idx = (tmp$_0_1 = index_1, index_1 = tmp$_0_1 + 1 | 0, tmp$_0_1);
      tmp$_3.call(destination_1, item_1 === index_0 ? idx : null);
    }
    tmp$_1.call(destination_0, filterNotNull(destination_1));
  }
  spriteIndexes = destination_0;
  olympicForces = listOf([forceRadial(olympicForces$lambda), forceNBody(olympicForces$lambda_0)]);
  radialForces = listOf([forceRadial(radialForces$lambda), forceNBody(radialForces$lambda_0)]);
  diagonalForces = listOf([forceNBody(diagonalForces$lambda), forceY(diagonalForces$lambda_0), forceX(diagonalForces$lambda_1)]);
  spriteForces = listOf([forceNBody(spriteForces$lambda), forceY(spriteForces$lambda_0), forceX(spriteForces$lambda_1)]);
  forces = listOf([new Pair('radial', radialForces), new Pair('diagonal', diagonalForces), new Pair('olympic', olympicForces), new Pair('sprite', spriteForces)]);
  forceIndex = 0;
  var $receiver_2 = newGroup();
  set_simulation(forceSimulation(root$lambda$lambda));
  updateSimulation();
  root = $receiver_2;
  main([]);
  return _;
}));

//# sourceMappingURL=ex-force-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/ex-force-js.js
// module id = 5
// module chunks = 0